import { render, staticRenderFns } from "./MatchPotentialTab.vue?vue&type=template&id=0f38d02a&scoped=true&"
import script from "./MatchPotentialTab.vue?vue&type=script&lang=js&"
export * from "./MatchPotentialTab.vue?vue&type=script&lang=js&"
import style0 from "./MatchPotentialTab.vue?vue&type=style&index=0&id=0f38d02a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f38d02a",
  null
  
)

export default component.exports